import { useAuth } from '../../../../hooks/useAuth';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import { useEnv } from '../../../../context/env-context';

function ProfileRoleForm() {
  const { user } = useAuth();
  const { audience } = useEnv();

  return (
    <Row className="mt-3 mb-2 align-items-center">
      <Col md={2}>
        <Form.Label>Role:</Form.Label>
      </Col>
      <Col md={4}>
        <Form.Control
          className="bo-input"
          type="text"
          name="role"
          id="role"
          placeholder="Role"
          value={user[`${audience}/metadata`].role}
          disabled
        />
      </Col>
    </Row>
  );
}

export default ProfileRoleForm;
